import { render, staticRenderFns } from "./FileLoader.vue?vue&type=template&id=d06945ee&scoped=true&"
import script from "./FileLoader.vue?vue&type=script&lang=js&"
export * from "./FileLoader.vue?vue&type=script&lang=js&"
import style0 from "./FileLoader.vue?vue&type=style&index=0&id=d06945ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06945ee",
  null
  
)

export default component.exports